import React from 'react'
import { Link } from 'react-router-dom'
import styled, { withTheme } from 'styled-components'
import is from 'styled-is'

import { fontSmoothing } from '../styles'
import { Toggle } from './forms'

const Divider = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  color: currentColor;

  &::before,
  &::after {
    flex-shrink: 1;
    flex-grow: 1;
    content: '';
    display: block;
    border-top: 1px solid currentColor;
  }
`

let Title = ({ children, className, to, onClick }) => {
  const Tag = to ? Link : onClick ? 'a' : 'span'
  return (
    <Tag onClick={onClick} to={to} className={className}>
      {children}
    </Tag>
  )
}

Title = styled(Title)`
  color: currentColor;
  text-decoration: none;
  font-size: ${({ theme }) => theme.font.body};
  font-weight: bold;
  flex: 1.2em 0 0;
  text-align: center;

  margin-bottom: 16px;

  ${fontSmoothing};

  ${is('onClick')`
    cursor: pointer;
  `};
`

const ToggleContainer = styled(Divider)`
  margin-left: -32px;
  margin-right: -32px;
`

const Background = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex: 1;
`

const Children = styled.div`
  display: flex;
  flex-grow: 1;
  justify-content: space-around;
`

const QuickSummary = withTheme(
  ({ className, title, to, onClick, children, checked, onChange, action }) => (
    <Background className={className}>
      <Title onClick={onClick} to={to} title={title}>
        {title}
      </Title>
      <Children>{children}</Children>
      <ToggleContainer>
        {action || <Toggle checked={checked} onChange={onChange} />}
      </ToggleContainer>
    </Background>
  )
)

export default styled(QuickSummary)`
  padding: 32px;
  border-radius: 16px;
  max-width: 100%;

  ${is('image')`
    background-image: url(${(props) => props.image});
  `};
  background-color: ${(props) => props.theme.colors.gray};

  ${is('dimmed')`
    background-blend-mode: multiply;
  `};

  color: ${(props) => props.theme.colors.background};
`

export const SummaryList = styled.ul`
  margin: 0 0 32px;
  padding: 0;

  display: grid;
  grid-template-columns: repeat(auto-fit, 240px);
  grid-template-rows: repeat(auto-fit, 206px);
  grid-gap: 2rem;
`

export const SummaryListItem = styled.li`
  height: 206px;
  display: flex;
  ${is('order')`
    order: ${(props) => props.order}
  `};
`
